<div class="left-menu-container">
    <!-- Sidebar Header (Fixed and Non-Scrollable) -->
    <div class="left-menu-header" [class.collapsed-header]="isCollapsed">
        <div *ngIf="!isCollapsed" class="logo-container">
            <img src="assets/login/logo.png" class="logo-img" alt="captech logo">
        </div>

        <!-- Toggle Button inside header -->
        <button class="sidebar-toggle-btn-new" [class.collapsed-btn-new]="isCollapsed" (click)="toggleMenu()">
            <!-- Collapsed: Fill Right -->
            <svg *ngIf="isCollapsed" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="toggle-svg">
                <rect x="3" y="3" width="18" height="18" rx="3" fill="none" stroke-width="2" />
                <path d="M 12,3 L 18,3 A 3,3 0 0 1 21,6 L 21,18 A 3,3 0 0 1 18,21 L 12,21 Z" />
            </svg>
            <!-- Expanded: Fill Left -->
            <svg *ngIf="!isCollapsed" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="toggle-svg">
                <rect x="3" y="3" width="18" height="18" rx="3" fill="none" stroke-width="2" />
                <path d="M 6,3 L 12,3 L 12,21 L 6,21 A 3,3 0 0 1 3,18 L 3,6 A 3,3 0 0 1 6,3 Z" />
            </svg>
        </button>
    </div>

    <!-- Scrollable content -->
    <cdk-virtual-scroll-viewport itemSize="50" class="scroller" [class.collapsed-menu]="isCollapsed">
        <div (click)="menuClick($event)">


            <a *ngIf="showMenu('dashboard')" class="outer-nav-link  " routerLink="/dashboard" routerLinkActive="active"
                fxLayout="row" fxLayoutAlign="start center" style="margin-left: 0%;" [matTooltipDisabled]="!isCollapsed"
                [matTooltip]="'leftMenu.dashboard' | translate" matTooltipClass="custom-mat-tooltip"
                matTooltipPosition="right">
                <mat-icon class="nav-icon">bar_chart</mat-icon>
                {{'leftMenu.dashboard'|
                translate}}
            </a>
            <a *ngIf="showMenu('gcProfile')" class="outer-nav-link  tabs" routerLink="/profile/general-contractor"
                routerLinkActive="active" fxLayout="row" fxLayoutAlign="start center"
                [matTooltipDisabled]="!isCollapsed" [matTooltip]="'leftMenu.companyProfile' | translate"
                matTooltipClass="custom-mat-tooltip" matTooltipPosition="right">
                <mat-icon class="nav-icon">domain</mat-icon>
                {{'leftMenu.companyProfile'|
                translate}}
            </a>
            <a *ngIf="showMenu('lcProfile')" class="outer-nav-link  tabs" routerLink="/profile/sub-contractor"
                routerLinkActive="active" fxLayout="row" fxLayoutAlign="start center"
                [matTooltipDisabled]="!isCollapsed" [matTooltip]="'leftMenu.companyProfile' | translate"
                matTooltipClass="custom-mat-tooltip" matTooltipPosition="right">
                <mat-icon class="nav-icon">domain</mat-icon>
                {{'leftMenu.companyProfile'| translate}}
            </a>

            <mat-accordion class="nav-accordion" multi>

                <!-- users -->
                <!-- <mat-expansion-panel *ngIf="captechUsers && !gc_admin">
                <mat-expansion-panel-header [matTooltipDisabled]="!isCollapsed" matTooltip="Administration" matTooltipClass="custom-mat-tooltip" matTooltipPosition="right">
    <div fxLayout="row" fxLayoutAlign="start center">
        <mat-icon class="nav-icon" style="margin-right: 10px;">folder</mat-icon>
        <span>Administration</span>
    </div>
</mat-expansion-panel-header>
                <div>
                    <a class="outer-nav-link" routerLink="/admin/kyc" routerLinkActive="active" fxLayout="row"
                    fxLayoutAlign="start center" [matTooltipDisabled]="!isCollapsed" matTooltip="KYC Score" matTooltipClass="custom-mat-tooltip" matTooltipPosition="right">KYC Score</a>
                </div>
            </mat-expansion-panel> -->
                <!-- <a class="outer-nav-link" routerLink="/admin/inApp/list" routerLinkActive="active" fxLayout="row" fxLayoutAlign="start center" [matTooltipDisabled]="!isCollapsed" matTooltip="In App" matTooltipClass="custom-mat-tooltip" matTooltipPosition="right">In App</a> -->

                <!-- users -->
                <mat-expansion-panel *ngIf="showMenu('securityGroup')">
                    <mat-expansion-panel-header [matTooltipDisabled]="!isCollapsed"
                        [matTooltip]="'leftMenu.security' | translate" matTooltipClass="custom-mat-tooltip"
                        matTooltipPosition="right">
                        <div fxLayout="row" fxLayoutAlign="start center">
                            <mat-icon class="nav-icon" style="margin-right: 10px;">security</mat-icon>
                            <span><!-- {{'leftMenu.userPermission'| translate}} -->
                                {{'leftMenu.security'| translate}}</span>
                        </div>
                    </mat-expansion-panel-header>
                    <div>
                        <a *ngIf="showMenu('roleList')" class="outer-nav-link" routerLink="/users/role/list"
                            routerLinkActive="active" fxLayout="row" fxLayoutAlign="start center"
                            [matTooltipDisabled]="!isCollapsed" [matTooltip]="'leftMenu.role' | translate"
                            matTooltipClass="custom-mat-tooltip" matTooltipPosition="right"><mat-icon
                                class="nav-icon">manage_accounts</mat-icon>{{'leftMenu.role'| translate}}</a>
                        <a *ngIf="showMenu('usersList')" class="outer-nav-link" routerLink="/users/users/list"
                            routerLinkActive="active" fxLayout="row" fxLayoutAlign="start center"
                            [matTooltipDisabled]="!isCollapsed" [matTooltip]="'leftMenu.users' | translate"
                            matTooltipClass="custom-mat-tooltip" matTooltipPosition="right"><mat-icon
                                class="nav-icon">group</mat-icon>{{'leftMenu.users'|
                            translate}}</a>
                    </div>
                </mat-expansion-panel>


                <!-- masters -->
                <mat-expansion-panel *ngIf="showMenu('masterGroup')">
                    <mat-expansion-panel-header [matTooltipDisabled]="!isCollapsed"
                        [matTooltip]="'leftMenu.master' | translate" matTooltipClass="custom-mat-tooltip"
                        matTooltipPosition="right">
                        <div fxLayout="row" fxLayoutAlign="start center">
                            <mat-icon class="nav-icon" style="margin-right: 10px;">settings_applications</mat-icon>
                            <span>{{'leftMenu.master'|translate}}</span>
                        </div>
                    </mat-expansion-panel-header>
                    <div class="left-menu">
                        <a *ngIf="showMenu('specialisation')" class="outer-nav-link"
                            routerLink="/master/specialisation/list" routerLinkActive="active" fxLayout="row"
                            fxLayoutAlign="start center" [matTooltipDisabled]="!isCollapsed"
                            [matTooltip]="'leftMenu.specialization' | translate" matTooltipClass="custom-mat-tooltip"
                            matTooltipPosition="right"><mat-icon
                                class="nav-icon">category</mat-icon>{{'leftMenu.specialization'| translate}}</a>
                        <a *ngIf="showMenu('activity')" class="outer-nav-link" routerLink="/master/activity/list"
                            routerLinkActive="active" fxLayout="row" fxLayoutAlign="start center"
                            [matTooltipDisabled]="!isCollapsed" [matTooltip]="'leftMenu.activity' | translate"
                            matTooltipClass="custom-mat-tooltip" matTooltipPosition="right"><mat-icon
                                class="nav-icon">assignment</mat-icon>{{'leftMenu.activity'| translate}}</a>
                        <a *ngIf="showMenu('subActivity')" class="outer-nav-link" routerLink="/master/sub-activity/list"
                            routerLinkActive="active" fxLayout="row" fxLayoutAlign="start center"
                            [matTooltipDisabled]="!isCollapsed" [matTooltip]="'leftMenu.subActivity' | translate"
                            matTooltipClass="custom-mat-tooltip" matTooltipPosition="right"><mat-icon
                                class="nav-icon">list_alt</mat-icon>{{'leftMenu.subActivity'| translate}}</a>
                        <a *ngIf="showMenu('transportArrangement')" class="outer-nav-link"
                            routerLink="/master/transport-arrangement/list" routerLinkActive="active" fxLayout="row"
                            fxLayoutAlign="start center" [matTooltipDisabled]="!isCollapsed"
                            [matTooltip]="'leftMenu.transportArrangement' | translate"
                            matTooltipClass="custom-mat-tooltip" matTooltipPosition="right"><mat-icon
                                class="nav-icon">commute</mat-icon>{{'leftMenu.transportArrangement'| translate}}</a>
                        <a *ngIf="showMenu('kharchiCreditPeriod')" class="outer-nav-link"
                            routerLink="/master/kharchi-credit-period/list" routerLinkActive="active" fxLayout="row"
                            fxLayoutAlign="start center" [matTooltipDisabled]="!isCollapsed"
                            [matTooltip]="'leftMenu.kharchiCreditPeriod' | translate"
                            matTooltipClass="custom-mat-tooltip" matTooltipPosition="right"><mat-icon
                                class="nav-icon">date_range</mat-icon>{{'leftMenu.kharchiCreditPeriod'| translate}}</a>
                        <a *ngIf="showMenu('raBillCreditPeriod')" class="outer-nav-link"
                            routerLink="/master/ra-bill-credit-period/list" routerLinkActive="active" fxLayout="row"
                            fxLayoutAlign="start center" [matTooltipDisabled]="!isCollapsed"
                            [matTooltip]="'leftMenu.rabillCreditPeriod' | translate"
                            matTooltipClass="custom-mat-tooltip" matTooltipPosition="right"><mat-icon
                                class="nav-icon">account_balance_wallet</mat-icon>{{'leftMenu.rabillCreditPeriod'|
                            translate}}</a>
                        <a *ngIf="showMenu('typeOfRoads')" class="outer-nav-link"
                            routerLink="/master/type-of-roads/list" routerLinkActive="active" fxLayout="row"
                            fxLayoutAlign="start center" [matTooltipDisabled]="!isCollapsed"
                            [matTooltip]="'leftMenu.typeOfRoad' | translate" matTooltipClass="custom-mat-tooltip"
                            matTooltipPosition="right"><mat-icon
                                class="nav-icon">add_road</mat-icon>{{'leftMenu.typeOfRoad'| translate}}</a>
                        <a *ngIf="showMenu('functionOfRoad')" class="outer-nav-link"
                            routerLink="/master/function-of-road/list" routerLinkActive="active" fxLayout="row"
                            fxLayoutAlign="start center" [matTooltipDisabled]="!isCollapsed"
                            [matTooltip]="'leftMenu.functionOfRoad' | translate" matTooltipClass="custom-mat-tooltip"
                            matTooltipPosition="right"><mat-icon
                                class="nav-icon">alt_route</mat-icon>{{'leftMenu.functionOfRoad'| translate}}</a>
                        <a *ngIf="showMenu('typeOfWork')" class="outer-nav-link" routerLink="/master/type-of-work/list"
                            routerLinkActive="active" fxLayout="row" fxLayoutAlign="start center"
                            [matTooltipDisabled]="!isCollapsed" [matTooltip]="'leftMenu.typeOfWork' | translate"
                            matTooltipClass="custom-mat-tooltip" matTooltipPosition="right"><mat-icon
                                class="nav-icon">construction</mat-icon>{{'leftMenu.typeOfWork'| translate}}</a>

                        <a *ngIf="showMenu('brandMake')" class="outer-nav-link" routerLink="/master/brand-make/list"
                            routerLinkActive="active" fxLayout="row" fxLayoutAlign="start center"
                            [matTooltipDisabled]="!isCollapsed" [matTooltip]="'leftMenu.brandMake' | translate"
                            matTooltipClass="custom-mat-tooltip" matTooltipPosition="right"><mat-icon
                                class="nav-icon">branding_watermark</mat-icon>{{'leftMenu.brandMake'|
                            translate}}</a>
                        <a *ngIf="showMenu('categorization')" class="outer-nav-link"
                            routerLink="/master/categorization/list" routerLinkActive="active" fxLayout="row"
                            fxLayoutAlign="start center" [matTooltipDisabled]="!isCollapsed"
                            [matTooltip]="'leftMenu.categorization' | translate" matTooltipClass="custom-mat-tooltip"
                            matTooltipPosition="right"><mat-icon
                                class="nav-icon">format_list_bulleted</mat-icon>{{'leftMenu.categorization'|
                            translate}}</a>
                        <a *ngIf="showMenu('materialCategory')" class="outer-nav-link"
                            routerLink="/master/material-category/list" routerLinkActive="active" fxLayout="row"
                            fxLayoutAlign="start center" [matTooltipDisabled]="!isCollapsed"
                            [matTooltip]="'leftMenu.materialCategory' | translate" matTooltipClass="custom-mat-tooltip"
                            matTooltipPosition="right"><mat-icon
                                class="nav-icon">inventory_2</mat-icon>{{'leftMenu.materialCategory'| translate}}</a>
                        <a *ngIf="showMenu('materialSubCategory')" class="outer-nav-link"
                            routerLink="/master/material-sub-category/list" routerLinkActive="active" fxLayout="row"
                            fxLayoutAlign="start center" [matTooltipDisabled]="!isCollapsed"
                            [matTooltip]="'leftMenu.materialSubCategory' | translate"
                            matTooltipClass="custom-mat-tooltip" matTooltipPosition="right"><mat-icon
                                class="nav-icon">subdirectory_arrow_right</mat-icon>{{'leftMenu.materialSubCategory'|
                            translate}}</a>

                        <!--- status---->
                        <mat-expansion-panel *ngIf="showMenu('statusGroup')">
                            <mat-expansion-panel-header [style.margin-left]="isCollapsed ? '0px' : '20px'"
                                [matTooltipDisabled]="!isCollapsed" [matTooltip]="'leftMenu.status' | translate"
                                matTooltipClass="custom-mat-tooltip" matTooltipPosition="right">
                                <div fxLayout="row" fxLayoutAlign="start center">
                                    <mat-icon class="nav-icon" style="margin-right: 10px;">traffic</mat-icon>
                                    <span>{{'leftMenu.status'|translate}}</span>
                                </div>
                            </mat-expansion-panel-header>
                            <div [style.margin-left]="isCollapsed ? '0px' : '10px'">
                                <a *ngIf="showMenu('supplyStatus')" class="outer-nav-link"
                                    routerLink="/master/Supply-status/list" routerLinkActive="active" fxLayout="row"
                                    fxLayoutAlign="start center" [matTooltipDisabled]="!isCollapsed"
                                    [matTooltip]="'leftMenu.supplyStatus' | translate"
                                    matTooltipClass="custom-mat-tooltip" matTooltipPosition="right"> <mat-icon
                                        class="nav-icon">inventory</mat-icon> {{'leftMenu.supplyStatus'| translate}}</a>
                                <a *ngIf="showMenu('requisitionStatus')" class="outer-nav-link"
                                    routerLink="/master/Requistion-status/list" routerLinkActive="active" fxLayout="row"
                                    fxLayoutAlign="start center" [matTooltipDisabled]="!isCollapsed"
                                    [matTooltip]="'leftMenu.requistionStatus' | translate"
                                    matTooltipClass="custom-mat-tooltip" matTooltipPosition="right"><mat-icon
                                        class="nav-icon">fact_check</mat-icon>{{'leftMenu.requistionStatus'|
                                    translate}}</a>
                                <a *ngIf="showMenu('projectStatus')" class="outer-nav-link"
                                    routerLink="/master/project-status/list" routerLinkActive="active" fxLayout="row"
                                    fxLayoutAlign="start center" [matTooltipDisabled]="!isCollapsed"
                                    [matTooltip]="'leftMenu.projectStatus' | translate"
                                    matTooltipClass="custom-mat-tooltip" matTooltipPosition="right"><mat-icon
                                        class="nav-icon">analytics</mat-icon>{{'leftMenu.projectStatus'| translate}}</a>
                            </div>
                        </mat-expansion-panel>
                        <!---project status---->
                        <mat-expansion-panel *ngIf="showMenu('projectCurrentStatusGroup')">
                            <mat-expansion-panel-header [style.margin-left]="isCollapsed ? '0px' : '20px'"
                                [matTooltipDisabled]="!isCollapsed"
                                [matTooltip]="'leftMenu.projectCurrentStatus' | translate"
                                matTooltipClass="custom-mat-tooltip" matTooltipPosition="right">
                                <div fxLayout="row" fxLayoutAlign="start center">
                                    <mat-icon class="nav-icon" style="margin-right: 10px;">traffic</mat-icon>
                                    <span>{{'leftMenu.projectCurrentStatus'| translate}}</span>
                                </div>
                            </mat-expansion-panel-header>
                            <div [style.margin-left]="isCollapsed ? '0px' : '10px'">

                                <a *ngIf="showMenu('rccSubStructure')" class="outer-nav-link"
                                    routerLink="/master/rcc-sub-structure/list" routerLinkActive="active" fxLayout="row"
                                    fxLayoutAlign="start center" [matTooltipDisabled]="!isCollapsed"
                                    [matTooltip]="'leftMenu.rccSubStructure' | translate"
                                    matTooltipClass="custom-mat-tooltip" matTooltipPosition="right"><mat-icon
                                        class="nav-icon">foundation</mat-icon>{{'leftMenu.rccSubStructure'|
                                    translate}}</a>
                                <a *ngIf="showMenu('rccSuperStructure')" class="outer-nav-link"
                                    routerLink="/master/rcc-super-structure/list" routerLinkActive="active"
                                    fxLayout="row" fxLayoutAlign="start center" [matTooltipDisabled]="!isCollapsed"
                                    [matTooltip]="'leftMenu.rccSuperStructuree' | translate"
                                    matTooltipClass="custom-mat-tooltip" matTooltipPosition="right"><mat-icon
                                        class="nav-icon">apartment</mat-icon>{{'leftMenu.rccSuperStructuree'|
                                    translate}}</a>
                                <a *ngIf="showMenu('blockWork')" class="outer-nav-link"
                                    routerLink="/master/block-work/list" routerLinkActive="active" fxLayout="row"
                                    fxLayoutAlign="start center" [matTooltipDisabled]="!isCollapsed"
                                    [matTooltip]="'leftMenu.blockWork' | translate" matTooltipClass="custom-mat-tooltip"
                                    matTooltipPosition="right"><mat-icon
                                        class="nav-icon">grid_on</mat-icon>{{'leftMenu.blockWork'| translate}}</a>
                                <a *ngIf="showMenu('internalPlaster')" class="outer-nav-link"
                                    routerLink="/master/internal-plaster/list" routerLinkActive="active" fxLayout="row"
                                    fxLayoutAlign="start center" [matTooltipDisabled]="!isCollapsed"
                                    [matTooltip]="'leftMenu.internalPlasterr' | translate"
                                    matTooltipClass="custom-mat-tooltip" matTooltipPosition="right"><mat-icon
                                        class="nav-icon">format_paint</mat-icon>{{'leftMenu.internalPlasterr'|
                                    translate}}</a>
                            </div>
                        </mat-expansion-panel>
                    </div>
                </mat-expansion-panel>

                <a *ngIf="showMenu('generalContractor')" style="cursor: pointer;" class="outer-nav-link tabs"
                    (click)="menu_Click('/general-contractor/list')" routerLinkActive="active" fxLayout="row"
                    fxLayoutAlign="start center" [matTooltipDisabled]="!isCollapsed"
                    [matTooltip]="'leftMenu.generalContractor' | translate" matTooltipClass="custom-mat-tooltip"
                    matTooltipPosition="right">
                    <mat-icon class="nav-icon">business</mat-icon>
                    {{'leftMenu.generalContractor'| translate}}
                </a>
                <a *ngIf="showMenu('subContractor')" class="outer-nav-link tabs" routerLink="/sub-contractor/list"
                    routerLinkActive="active" fxLayout="row" fxLayoutAlign="start center"
                    [matTooltipDisabled]="!isCollapsed" [matTooltip]="'leftMenu.subContractor' | translate"
                    matTooltipClass="custom-mat-tooltip" matTooltipPosition="right">
                    <mat-icon class="nav-icon">engineering</mat-icon>
                    {{'leftMenu.subContractor'|
                    translate}}
                </a>
                <a *ngIf="showMenu('supplier')" class="outer-nav-link tabs" routerLink="/supplier/list"
                    routerLinkActive="active" fxLayout="row" fxLayoutAlign="start center"
                    [matTooltipDisabled]="!isCollapsed" [matTooltip]="'leftMenu.supplier' | translate"
                    matTooltipClass="custom-mat-tooltip" matTooltipPosition="right">
                    <mat-icon class="nav-icon">local_shipping</mat-icon>
                    {{'leftMenu.supplier'| translate}}
                </a>
                <a *ngIf="showMenu('project')" class="outer-nav-link tabs" routerLink="/project/list"
                    routerLinkActive="active" fxLayout="row" fxLayoutAlign="start center"
                    [matTooltipDisabled]="!isCollapsed" [matTooltip]="'leftMenu.project' | translate"
                    matTooltipClass="custom-mat-tooltip" matTooltipPosition="right"><mat-icon
                        class="nav-icon">business_center</mat-icon>{{'leftMenu.project'| translate}}</a>

                <a *ngIf="showMenu('upcomingProjects')" class="outer-nav-link tabs"
                    routerLink="/project/upcoming-projects/list" routerLinkActive="active" fxLayout="row"
                    fxLayoutAlign="start center" [matTooltipDisabled]="!isCollapsed" [matTooltip]="'leftMenu.upcomingProjects' | translate"
                    matTooltipClass="custom-mat-tooltip" matTooltipPosition="right">
                    <mat-icon class="nav-icon">upcoming</mat-icon>{{'leftMenu.upcomingProjects'| translate}}</a>


                <a *ngIf="showMenu('requisition')" class="outer-nav-link tabs" routerLink="/requisition/list"
                    routerLinkActive="active" fxLayout="row" fxLayoutAlign="start center"
                    [matTooltipDisabled]="!isCollapsed" [matTooltip]="'leftMenu.requisition' | translate"
                    matTooltipClass="custom-mat-tooltip" matTooltipPosition="right">
                    <mat-icon class="nav-icon">search</mat-icon>
                    {{'leftMenu.requisition'| translate}}
                </a>


                <a *ngIf="showMenu('supply')" class="outer-nav-link tabs" routerLink="/supply/list"
                    routerLinkActive="active" fxLayout="row" fxLayoutAlign="start center"
                    [matTooltipDisabled]="!isCollapsed" [matTooltip]="'leftMenu.supply' | translate"
                    matTooltipClass="custom-mat-tooltip" matTooltipPosition="right">
                    <mat-icon class="nav-icon">inventory_2</mat-icon>
                    {{'leftMenu.supply'| translate}}
                </a>

                <a *ngIf="showMenu('connect')" class="outer-nav-link tabs" routerLink="/requisition/connect"
                    routerLinkActive="active" fxLayout="row" fxLayoutAlign="start center"
                    [matTooltipDisabled]="!isCollapsed" [matTooltip]="'leftMenu.connect' | translate"
                    matTooltipClass="custom-mat-tooltip" matTooltipPosition="right"><mat-icon class="nav-icon">hub</mat-icon>{{'leftMenu.connect'| translate}}</a>

                <a *ngIf="showMenu('serviceRequestWO')" class="outer-nav-link tabs"
                    routerLink="/service-request-wo/list" routerLinkActive="active" fxLayout="row"
                    fxLayoutAlign="start center" [matTooltipDisabled]="!isCollapsed" [matTooltip]="'leftMenu.serviceRequestWO' | translate"
                    matTooltipClass="custom-mat-tooltip" matTooltipPosition="right">
                    <mat-icon class="nav-icon">assignment_turned_in</mat-icon>
                    {{'leftMenu.serviceRequestWO'| translate}}
                </a>

                <a *ngIf="showMenu('workOrder')" class="outer-nav-link tabs" routerLink="/work-order/list"
                    routerLinkActive="active" fxLayout="row" fxLayoutAlign="start center"
                    [matTooltipDisabled]="!isCollapsed" [matTooltip]="'leftMenu.workOrder' | translate"
                    matTooltipClass="custom-mat-tooltip" matTooltipPosition="right">
                    <mat-icon class="nav-icon">assignment</mat-icon>
                    {{'leftMenu.workOrder'| translate}}
                </a>



                <a *ngIf="showMenu('inwardBilling')" class="outer-nav-link tabs" routerLink="/inward-billing/list"
                    routerLinkActive="active" fxLayout="row" fxLayoutAlign="start center"
                    [matTooltipDisabled]="!isCollapsed" [matTooltip]="'leftMenu.inwardBilling' | translate" matTooltipClass="custom-mat-tooltip"
                    matTooltipPosition="right">
                    <mat-icon class="nav-icon">receipt_long</mat-icon>
                    {{'leftMenu.inwardBilling'| translate}}
                </a>

                <a *ngIf="showMenu('bill')" class="outer-nav-link tabs" routerLink="/bill/list"
                    routerLinkActive="active" fxLayout="row" fxLayoutAlign="start center"
                    [matTooltipDisabled]="!isCollapsed" [matTooltip]="'leftMenu.bill' | translate"
                    matTooltipClass="custom-mat-tooltip" matTooltipPosition="right"><mat-icon
                        class="nav-icon">receipt</mat-icon>{{'leftMenu.bill'|
                    translate}}</a>

                <!-- dpr Main menu -->
                <mat-expansion-panel *ngIf="showMenu('dprGroup')">
                    <mat-expansion-panel-header [matTooltipDisabled]="!isCollapsed" [matTooltip]="'leftMenu.dpr' | translate"
                        matTooltipClass="custom-mat-tooltip" matTooltipPosition="right">
                        <div fxLayout="row" fxLayoutAlign="start center">
                            <mat-icon class="nav-icon" style="margin-right: 10px;">description</mat-icon>
                            <span>{{'leftMenu.dpr'| translate}}</span>
                        </div>
                    </mat-expansion-panel-header>
                    <div>

                        <a *ngIf="showMenu('dprDashboard')" class="outer-nav-link " routerLink="/dpr/dashboard"
                            routerLinkActive="active" fxLayout="row" fxLayoutAlign="start center"
                            [matTooltipDisabled]="!isCollapsed" [matTooltip]="'leftMenu.dashboard' | translate"
                            matTooltipClass="custom-mat-tooltip" matTooltipPosition="right"><mat-icon
                                class="nav-icon">dashboard</mat-icon>{{'leftMenu.dashboard'| translate}}</a>
                        <a *ngIf="showMenu('dprMonthlyPlan')" class="outer-nav-link "
                            routerLink="/dpr/monthly-plan/list" routerLinkActive="active" fxLayout="row"
                            fxLayoutAlign="start center" [matTooltipDisabled]="!isCollapsed"
                            [matTooltip]="'leftMenu.dpr-monthly' | translate" matTooltipClass="custom-mat-tooltip"
                            matTooltipPosition="right"><mat-icon
                                class="nav-icon">calendar_month</mat-icon>{{'leftMenu.dpr-monthly'|
                            translate}}</a>
                        <a *ngIf="showMenu('dprDailyEntry')" class="outer-nav-link " routerLink="/dpr/daily-entry/list"
                            routerLinkActive="active" fxLayout="row" fxLayoutAlign="start center"
                            [matTooltipDisabled]="!isCollapsed" [matTooltip]="'leftMenu.dpr-daily' | translate"
                            matTooltipClass="custom-mat-tooltip" matTooltipPosition="right"><mat-icon
                                class="nav-icon">today</mat-icon>{{'leftMenu.dpr-daily'|
                            translate}}</a>

                    </div>
                </mat-expansion-panel>
                <!-- dpr Main menu -->

                <a *ngIf="showMenu('workOrderRating')" class="outer-nav-link tabs" routerLink="/work-order-rating/list"
                    routerLinkActive="active" fxLayout="row" fxLayoutAlign="start center"
                    [matTooltipDisabled]="!isCollapsed" [matTooltip]="'leftMenu.workOrderRating' | translate"
                    matTooltipClass="custom-mat-tooltip" matTooltipPosition="right"><mat-icon
                        class="nav-icon">star_rate</mat-icon>{{'leftMenu.workOrderRating'| translate}}</a>












                <a *ngIf="showMenu('bulkNotification')" class="outer-nav-link tabs" routerLink="/bulk-notification/list"
                    routerLinkActive="active" fxLayout="row" fxLayoutAlign="start center"
                    [matTooltipDisabled]="!isCollapsed" [matTooltip]="'leftMenu.bulkNotification' | translate"
                    matTooltipClass="custom-mat-tooltip" matTooltipPosition="right">
                    <mat-icon class="nav-icon">notifications_active</mat-icon>
                    {{'leftMenu.bulkNotification'|
                    translate}}
                </a>

                <mat-expansion-panel *ngIf="showMenu('reportsGroup')">
                    <mat-expansion-panel-header [matTooltipDisabled]="!isCollapsed" [matTooltip]="'leftMenu.reports' | translate"
                        matTooltipClass="custom-mat-tooltip" matTooltipPosition="right">
                        <div fxLayout="row" fxLayoutAlign="start center">
                            <mat-icon class="nav-icon" style="margin-right: 10px;">pie_chart</mat-icon>
                            <span>{{'leftMenu.reports'| translate}}</span>
                        </div>
                    </mat-expansion-panel-header>
                    <div>
                        <a *ngIf="showMenu('reportInApp')" class="outer-nav-link" routerLink="/reports/InApp"
                            routerLinkActive="active" fxLayout="row" fxLayoutAlign="start center"
                            [matTooltipDisabled]="!isCollapsed" [matTooltip]="'leftMenu.reportInApp' | translate"
                            matTooltipClass="custom-mat-tooltip" matTooltipPosition="right"><mat-icon
                                class="nav-icon">campaign</mat-icon>{{'leftMenu.reportInApp'| translate}}</a>

                        <a *ngIf="showMenu('reportAltius')" class="outer-nav-link" routerLink="/reports/altius"
                            routerLinkActive="active" fxLayout="row" fxLayoutAlign="start center"
                            [matTooltipDisabled]="!isCollapsed" [matTooltip]="'leftMenu.reportAltius' | translate"
                            matTooltipClass="custom-mat-tooltip" matTooltipPosition="right"><mat-icon
                                class="nav-icon">receipt_long</mat-icon>{{'leftMenu.reportAltius'| translate}}</a>

                        <a *ngIf="showMenu('reportYoucon')" class="outer-nav-link" routerLink="/reports/youcon"
                            routerLinkActive="active" fxLayout="row" fxLayoutAlign="start center"
                            [matTooltipDisabled]="!isCollapsed" [matTooltip]="'leftMenu.reportYoucon' | translate"
                            matTooltipClass="custom-mat-tooltip" matTooltipPosition="right"><mat-icon
                                class="nav-icon">assessment</mat-icon>{{'leftMenu.reportYoucon'| translate}}</a>

                        <a *ngIf="showMenu('reportWhatsapp')" class="outer-nav-link" routerLink="/reports/whatsapp"
                            routerLinkActive="active" fxLayout="row" fxLayoutAlign="start center"
                            [matTooltipDisabled]="!isCollapsed" [matTooltip]="'leftMenu.reportWhatsapp' | translate"
                            matTooltipClass="custom-mat-tooltip" matTooltipPosition="right"><mat-icon
                                class="nav-icon">chat</mat-icon>{{'leftMenu.reportWhatsapp'| translate}}</a>

                        <a *ngIf="showMenu('reportSprint')" class="outer-nav-link" routerLink="/reports/sprint"
                            routerLinkActive="active" fxLayout="row" fxLayoutAlign="start center"
                            [matTooltipDisabled]="!isCollapsed" [matTooltip]="'leftMenu.reportSprint' | translate"
                            matTooltipClass="custom-mat-tooltip" matTooltipPosition="right"><mat-icon
                                class="nav-icon">run_circle</mat-icon>{{'leftMenu.reportSprint'| translate}}</a>

                        <a *ngIf="showMenu('reportGcDump')" class="outer-nav-link" routerLink="/reports/gcdump"
                            routerLinkActive="active" fxLayout="row" fxLayoutAlign="start center"
                            [matTooltipDisabled]="!isCollapsed" [matTooltip]="'leftMenu.reportGcDump' | translate"
                            matTooltipClass="custom-mat-tooltip" matTooltipPosition="right"><mat-icon
                                class="nav-icon">storage</mat-icon>{{'leftMenu.reportGcDump'| translate}}</a>

                        <a *ngIf="showMenu('reportLcDump')" class="outer-nav-link" routerLink="/reports/lcdump"
                            routerLinkActive="active" fxLayout="row" fxLayoutAlign="start center"
                            [matTooltipDisabled]="!isCollapsed" [matTooltip]="'leftMenu.reportLcDump' | translate"
                            matTooltipClass="custom-mat-tooltip" matTooltipPosition="right"><mat-icon
                                class="nav-icon">storage</mat-icon>{{'leftMenu.reportLcDump'| translate}}</a>

                        <!-- Analytics reports -->
                        <a *ngIf="showMenu('reportSummaryTradewise')" class="outer-nav-link"
                            routerLink="/reports/summary-dlr-tradewise-list" routerLinkActive="active" fxLayout="row"
                            fxLayoutAlign="start center" [matTooltipDisabled]="!isCollapsed"
                            [matTooltip]="'leftMenu.reportSummaryTradewise' | translate" matTooltipClass="custom-mat-tooltip"
                            matTooltipPosition="right"><mat-icon class="nav-icon">trending_up</mat-icon>{{'leftMenu.reportSummaryTradewise'| translate}}</a>

                        <a *ngIf="showMenu('reportSummaryVendorwise')" class="outer-nav-link"
                            routerLink="/reports/summary-dlr-vendorwise-list" routerLinkActive="active" fxLayout="row"
                            fxLayoutAlign="start center" [matTooltipDisabled]="!isCollapsed"
                            [matTooltip]="'leftMenu.reportSummaryVendorwise' | translate" matTooltipClass="custom-mat-tooltip"
                            matTooltipPosition="right"><mat-icon class="nav-icon">people_alt</mat-icon>{{'leftMenu.reportSummaryVendorwise'| translate}}</a>

                        <a *ngIf="showMenu('reportSubContractorPerformance')" class="outer-nav-link"
                            routerLink="/reports/sub-contractor-performance-list" routerLinkActive="active"
                            fxLayout="row" fxLayoutAlign="start center" [matTooltipDisabled]="!isCollapsed"
                            [matTooltip]="'leftMenu.reportSubContractorPerformance' | translate" matTooltipClass="custom-mat-tooltip"
                            matTooltipPosition="right"><mat-icon class="nav-icon">speed</mat-icon>{{'leftMenu.reportSubContractorPerformance'| translate}}</a>
                    </div>
                </mat-expansion-panel>

                <!-- Utilities -->
                <mat-expansion-panel *ngIf="showMenu('utilitiesGroup')">
                    <mat-expansion-panel-header [matTooltipDisabled]="!isCollapsed"
                        [matTooltip]="'leftMenu.utilities' | translate" matTooltipClass="custom-mat-tooltip"
                        matTooltipPosition="right">
                        <div fxLayout="row" fxLayoutAlign="start center">
                            <mat-icon class="nav-icon" style="margin-right: 10px;">build</mat-icon>
                            <span>{{'leftMenu.utilities'|translate}}</span>
                        </div>
                    </mat-expansion-panel-header>
                    <div>
                        <a *ngIf="showMenu('apiAuditLog')" class="outer-nav-link" routerLink="/utilities/api-audit-log"
                            routerLinkActive="active" fxLayout="row" fxLayoutAlign="start center"
                            [matTooltipDisabled]="!isCollapsed" [matTooltip]="'leftMenu.apiAuditLog' | translate"
                            matTooltipClass="custom-mat-tooltip" matTooltipPosition="right"><mat-icon
                                class="nav-icon">history_toggle_off</mat-icon>{{'leftMenu.apiAuditLog'| translate}}</a>
                    </div>
                </mat-expansion-panel>

                <a *ngIf="showMenu('resetCache')" (click)="resetCateche()" routerLink class="outer-nav-link tabs"
                    fxLayout="row" fxLayoutAlign="start center" [matTooltipDisabled]="!isCollapsed"
                    [matTooltip]="'leftMenu.resetCache' | translate" matTooltipClass="custom-mat-tooltip" matTooltipPosition="right">
                    <mat-icon class="nav-icon">cached</mat-icon>
                    {{'leftMenu.resetCache'| translate}}
                </a>

            </mat-accordion>

            <div style="margin-top: 20px; border-top: 1px solid #ccc; padding-top: 10px;">
                <a class="outer-nav-link tabs" routerLink="profile/list" routerLinkActive="active" fxLayout="row"
                    fxLayoutAlign="start center" [matTooltipDisabled]="!isCollapsed" [matTooltip]="'leftMenu.settings' | translate"
                    matTooltipClass="custom-mat-tooltip" matTooltipPosition="right">
                    <mat-icon class="nav-icon">settings</mat-icon>
                    {{'leftMenu.settings'| translate}}
                </a>
                <a class="outer-nav-link tabs logout-link" (click)="confirmLogoutPop()" fxLayout="row"
                    fxLayoutAlign="start center" style="cursor: pointer;" [matTooltipDisabled]="!isCollapsed"
                    [matTooltip]="'leftMenu.logout' | translate" matTooltipClass="custom-mat-tooltip" matTooltipPosition="right">
                    <mat-icon class="nav-icon">exit_to_app</mat-icon>
                    {{'leftMenu.logout'| translate}}
                </a>
            </div>

            <div style="height: 150px;"></div>
        </div>
    </cdk-virtual-scroll-viewport>

    <!-- Custom Logout Confirmation Modal -->
    <div class="custom-modal-overlay" *ngIf="showLogoutModal">
        <div class="custom-modal-box">
            <h3 class="custom-modal-title">{{'leftMenu.logoutModalTitle' | translate}}</h3>
            <hr class="custom-modal-divider">
            <div class="custom-modal-actions" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="15px">
                <button class="btn-confirm" (click)="confirmLogout()">{{'leftMenu.confirm' | translate}}</button>
                <button class="btn-cancel" (click)="cancelLogout()">{{'leftMenu.cancel' | translate}}</button>
            </div>
        </div>
    </div>

</div>